/**
 * Find the fields that are in the same scope as the active field.
 * Scope = top-level, container, or repeating-group siblings.
 */
export function findFieldPath(formSchema = { fields: [] }, activeKey) {
	const fields = formSchema.fields || [];

	const topIndex = fields.findIndex((f) => f.key === activeKey);
	if (topIndex !== -1) {
		return {
			type: "top",
			parentIndex: null,
			childIndex: topIndex,
			fields,
		};
	}

	for (let i = 0; i < fields.length; i++) {
		if (fields[i].name === "Container" && Array.isArray(fields[i].container)) {
			const idx = fields[i].container.findIndex((f) => f.key === activeKey);
			if (idx !== -1) {
				return {
					type: "container",
					parentIndex: i,
					childIndex: idx,
					fields: fields[i].container,
				};
			}
		}

		if (fields[i].name === "RepeatingGroup" && Array.isArray(fields[i].fields)) {
			const idx = fields[i].fields.findIndex((f) => f.key === activeKey);
			if (idx !== -1) {
				return {
					type: "group",
					parentIndex: i,
					childIndex: idx,
					fields: fields[i].fields,
				};
			}
		}
	}

	return null;
}

export function getSiblingFields(formSchema = { fields: [] }, activeKey) {
	const path = findFieldPath(formSchema, activeKey);
	if (!path) return [];
	return path.fields.filter((f) => f.key !== activeKey);
}

export function getScopeForField(formSchema, activeKey) {
	const path = findFieldPath(formSchema, activeKey);
	if (!path) return { type: "top", fields: [] };
	return { type: path.type, fields: path.fields };
}
